export default "__VITE_ASSET__CXdtKDHL__"